<!-- Sidebar Menu -->
<p-menu [styleClass]="'hidden xl:block'" [model]="items">
    <ng-template #start>
        <span class="inline-flex w-full justify-between items-center gap-1 px-4 py-2">
            <span class="text-xl font-semibold">
                CLIENT<span class="text-primary">QUEST</span>                  
            </span>
            <p-button (click)="toggleTheme()"
                      size="small" 
                      [text]="true" 
                      [icon]="isDarkMode() ? 'pi pi-moon' : 'pi pi-sun'" />
        </span>
    </ng-template>
    <ng-template #submenuheader let-item>
        <span class="text-primary font-bold">{{ item.label }}</span>
    </ng-template>
    <ng-template #item let-item>
        <a pRipple class="flex items-center p-menu-item-link" [routerLink]="item.routerLink">
            <span [class]="item.icon"></span>
            <span class="ml-2">{{ item.label }}</span>
        </a>
    </ng-template>
    <ng-template #end>
        <button pRipple class="relative overflow-hidden w-full border-0 bg-transparent flex items-center justify-start p-2 pl-4 hover:bg-surface-100 dark:hover:bg-surface-800 rounded-none cursor-pointer transition-colors duration-200">
            <p-avatar [label]="this.shortName" styleClass="mr-2" shape="circle" />
            <span class="inline-flex flex-col">
                <span class="font-bold">{{username}}</span>
            </span>
        </button>
    </ng-template>
</p-menu>

<!-- Mobile Menu -->
<p-menubar [styleClass]="'block xl:hidden rounded-none border-r-0 border-l-0'" [model]="items" />